<template>
  <hm-content title="">
    <div class="table-panel flex flex-start text-right">
      <div>
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="searchCondition.receiptSn"
          placeholder="请输入会员卡号"
        ></el-input>
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="searchCondition.goodsSn"
          placeholder="请输入会员手机号"
        ></el-input>
        <el-date-picker
          v-model="searchCondition.date"
          type="datetimerange"
          align="right"
          start-placeholder="请选择开卡时间段"
          end-placeholder="请选择开卡时间段"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          size="small"
          class=" mr10 time"
        ></el-date-picker>
        <el-select
          clearable
          v-model="searchCondition.commissionLevel"
          placeholder="请选择当前所属生理轴"
          size="small"
          class="mr10"
        >
          <!-- <el-option
          :label="v"
          :value="v"
          v-for="(v, i) in SeriesList"
          :key="i"
        ></el-option> -->
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button type="info" size="small" @click="searchCondition = {}"
          >重置</el-button
        >
      </div>
    </div>

    <div class="flex flex-start table-panel ">
      <el-button type="primary" size="small" @click="search"
        >生成报表</el-button
      >
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
        height="600"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiptSn"
          label="会员卡号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="oneCategoryName"
          label="开卡时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="twoCategoryName"
          label="会员名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="threeCategoryName"
          label="会员手机"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandName"
          label="会员生日"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="spuName"
          label="宝宝生日"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsSn"
          label="当前所属生理轴"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="specIdGroupName"
          label="累计消费次数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="barCode"
          label="累计消费金额"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsNum"
          label="最后一次消费时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalPrice"
          label="首单消费金额"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realPrice"
          label="首单消费时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realTotalPrice"
          label="所属导购"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="purchaseTime"
          label="所属导购工号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="deliveryType"
          label="导购所属门店"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      list: [],
      searchCondition: {}
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getParamsCookie();
  },
  mounted() {
    this.queryList();
  },
  methods: {
    setParamsCookie() {
      setCookie({
        key: "membershipCardListParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "membershipCardListParams",
        type: "session"
      });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList() {
      if (this.isArray(this.searchCondition.date)) {
        let params = {
          pageNo: this.currentPage,
          pageSize: this.pageSize
        };
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        searchCondition.purchaseStartTime =
          this.searchCondition.date && this.searchCondition.date.length > 0
            ? this.searchCondition.date[0]
            : "";
        searchCondition.purchaseEndTime =
          this.searchCondition.date && this.searchCondition.date.length > 0
            ? this.searchCondition.date[1]
            : "";
        searchCondition.wxshopCategoryId = this.isArray(
          searchCondition.wxshopCategoryId
        )
          ? searchCondition.wxshopCategoryId[
              searchCondition.wxshopCategoryId.length - 1
            ]
          : searchCondition.wxshopCategoryId;
        this.setParamsCookie();
        Object.assign(params, searchCondition);
        const { result } = await this.$store.dispatch("", params);
        const { records, total } = result;
        this.list = records;
        this.total = total;
      } else {
        this.$message({
          message: "请选择查询时间段！",
          type: "warning"
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
